import { useT } from '@/i18n';

/** The ORCA splash inside the app (same markup and styles as the first-frame
 *  splash in index.html): shown while the session or an incoming link is
 *  being checked, so every wait looks like one and the same brand moment. */
export function BrandPreloader({ text }: { text?: string }) {
  const { t } = useT('auth');
  return (
    <div className="orca-pl" role="status" aria-live="polite">
      <div className="orca-pl-glow" aria-hidden="true" />
      <div className="orca-pl-content">
        <img className="orca-pl-logo logo-d" src="/assets/brand/orca-logo.png" alt="ORCA" width={445} height={464} />
        <img className="orca-pl-logo logo-l" src="/assets/mascot/orca-logo-payment.png" alt="" width={433} height={455} />
        <p className="orca-pl-text">{text ?? t('preloader')}</p>
      </div>
    </div>
  );
}
